module.exports = __webpack_public_path__ + "static/media/check_availability_hebrew.20e214af.png";